export default __webpack_public_path__ + "static/media/lactose.91bfeb4f.svg";